import React from 'react';

import { CardBonuse } from '@/features/news-managment/ui/prepared-bonuses/components/card-bonuse';
import { TitlePrepared } from '@/features/news-managment/ui/prepared-bonuses/components/title-prepared';

import { WrapperBonuse, WrapperCardBonuse } from './styles';
import { useScopedI18n } from '@locales/client';

export const PreparedBonuses = ({ settings }) => {
  const { transformedBonuses } = settings;

  const tBonus = useScopedI18n('bonus');

  return (
    <WrapperBonuse>
      <TitlePrepared tBonus={tBonus} />
      <WrapperCardBonuse>
        {transformedBonuses?.map((el) => {
          return (
            <CardBonuse
              data={el}
              key={el.id}
              settings={settings}
              tBonus={tBonus}
            />
          );
        })}
      </WrapperCardBonuse>
    </WrapperBonuse>
  );
};
